import { useContext, useEffect } from 'react';
import { Box, Grid, Paper, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { DataDispatchContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function NewAccount() {
  const navigate = useNavigate()
  const dispatch: any = useContext(DataDispatchContext)

  useEffect(()=>{
    sendViewAnalytics('/dashboard', {
            domain: analyticsDomain.dashboard,
            name: analyticsPage.newCustomer
          })
  },[])

  function handleContactUs() {
    dispatch({
      type: 'setAcctSelected',
      acctSelected: 'help'
    })
    sendClickAnalytics('/dashboard', {
      domain: analyticsDomain.dashboard,
      name: analyticsCta.newCustomerContactUs,
      metadata: {},
    })
    navigate('/profile')
  }
  return (
    <Grid container id="NewAccountContent" 
            direction="row" display="flex"  
            justifyContent="flex-end" 
            spacing={custom.spacing.xxs} 
            width= "100%">
      <Paper id="NewAccount" elevation={0} 
            sx={{ 
              borderRadius: custom.corners5,
              border: custom.border, 
              width: "100%",
              backgroundColor: 'sz.colors.surfaceAccent',
              my: custom.spacing.md,
              ml: custom.spacing.sm,
              p: custom.spacing.md,
            }}
        >
          <Box component="img"
                src="images/roofIcon.svg"
              />  
          <Typography component="p" mt={custom.spacing.xxs}
              variant="szHeading.Bold.Medium">
              Welcome to SolarZero
          </Typography>
          <Box>
            <Typography component="p" mt={custom.spacing.xxs}
                variant="szBody.Regular.Medium">
                You’re now on your way to powering your home with cheaper, cleaner, smarter energy. Our team are currently running some final checks on your home to make sure you’ll be running on sunshine seamlessly soon. Stay tuned, and we’ll update you when you’re good to go.
                In the meantime, if you’ve got any questions, get in touch. Our team are happy to help.
            </Typography>
          </Box>
          <Button variant="contained" id="contactUsButton"
              onClick={handleContactUs}
              sx={{ mt: custom.spacing.sm, 
                px: custom.spacing.sm, 
                py: custom.spacing.xs }}>
            <Typography variant="szBody.Regular.Medium" color="#FFF">
                Contact us
            </Typography>
          </Button>
      </Paper>
    </Grid>   
  )
}
